module.exports = __webpack_public_path__ + "static/media/Camera17.354f3fe5.jpg";